const initialState = {
	hasContactsManagementPermission: false,
	hasTheBusinessPermission: false,
	hasDirectorySyncPermission: false,
	hasDeveloperApiPermission: false
};

const permissionReducer = ( state = initialState, action ) => {
	switch (action.type) {
		case "HAS_CONTACTS_MANAGEMENT_PERMISSION":
			state = {
				...state,
				hasContactsManagementPermission: action.payload
			};
			break;
		case "HAS_THE_BUSINESS_PERMISSION":
			state = {
				...state,
				hasTheBusinessPermission: action.payload
			};
			break;
		case "HAS_DIRECTORY_SYNC_PERMISSION":
			state = {
				...state,
				hasDirectorySyncPermission: action.payload
			};
			break;
		case "HAS_DEVELOPER_API_PERMISSION":
			state = {
				...state,
				hasDeveloperApiPermission: action.payload
			};
			break;
		default:
			return state;
	}
	return state;
};



export default permissionReducer;
